import e from "../../../utilities/tw.js";
const o = {
  primarySecondaryButtons: e`self-end whitespace-normal leading-1`,
  tertiaryButton: e`px-2`,
  tertiaryButtonContainer: e`flex justify-end pt-4 sm:justify-start sm:p-0`,
  primarySecondaryButtonContainer: e`flex flex-col-reverse gap-y-4 xs:ml-14 sm:flex-row sm:flex-nowrap sm:gap-6`,
  closeIcon: e`size-6 p-3`,
  iconButton: e`absolute right-2.5 top-2.5 inline-flex appearance-none justify-center text-neutral-inverse *:contents hover:rounded-md hover:bg-background hover:text-neutral-inverse focus-visible:bg-background focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-primary`,
  headingIcon: e`size-4`,
  modalContent: e`max-inset-0 fixed inset-x-4 top-1/2 z-1300 flex max-h-[85vh] -translate-y-1/2 flex-col content-center overflow-auto rounded-md bg-surface px-7 py-8 shadow-md xs:inset-x-6 sm:left-1/2 sm:right-auto sm:w-[584px] sm:-translate-x-1/2 md:w-[660px]`,
  modalDescription: e`pb-6 pt-3 text-body-md`,
  modalOverlay: e`fixed inset-0 z-1300 bg-surface-inverse/50`,
  modalTitle: e`flex items-center gap-3 pr-10 text-title-5 font-bold `
};
export {
  o as simpleModalStyles
};
